/* eslint-disable no-debugger */
import axios from 'axios';
import moment from 'moment';

import {
  isResponseValid,
  throwSAPError,
  CustomException,
  getListItemsCount,
  downloadExcel,
} from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import { GET_DELIVERY_TABLE_DATA, SET_DELIVERY_TABLE_STATUS } from '../helpers/types';

export const getDeliveryTableData = (
  skip,
  top,
  enqueueSnackbar = () => {},
  filterStr = ''
) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, idToken, BusinessPartner } = auth;
    dispatch({
      type: SET_DELIVERY_TABLE_STATUS,
      payload: { isLoading: true, failText: '' },
    });
    let config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `Customer eq '${BusinessPartner}'`,
      },
    };
    if (filterStr !== '') {
      config = {
        ...config,
        params: {
          ...config.params,
          $filter: `Customer eq '${BusinessPartner}' and ${filterStr}`,
        },
      };
    }
    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV`,
    });
    let listCount = null;
    if (listCount === null) {
      const url = `${systemIP}/ZAE_PB2B_SRV/ZAE_C_OutboundDeliveryLI_02`;
      listCount = await getListItemsCount(config, url);
    }
    if (skip === 0 || (listCount !== null && skip <= listCount)) {
      config.params = {
        ...config.params,
        $top: top,
        $skip: skip,
      };
      const response = await MainService.get('/ZAE_C_OutboundDeliveryLI_02', config).catch(
        throwSAPError
      );
      if (isResponseValid(response)) {
        const Data = response.data.d.results.map(r => ({
          ...r,
          DeliveryDate: moment(r.DeliveryDate).format('MMMM DD, YYYY'),
        }));
        dispatch({
          type: GET_DELIVERY_TABLE_DATA,
          payload: {
            data: Data,
            listCount,
          },
        });
      } else {
        throw new CustomException(i18n.t('deliveryScreenTranslations:INVALID_RESPONSE'));
      }
    }
  } catch (error) {
    dispatch({
      type: SET_DELIVERY_TABLE_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('deliveryScreenTranslations:ERR_MSG_1'),
      },
    });

    enqueueSnackbar(i18n.t('deliveryScreenTranslations:ERR_MSG_1'), {
      variant: 'error',
    });
  }
};

export const getAllDeliveryData = (skip, top, enqueueSnackbar = () => {}) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, idToken, BusinessPartner } = auth;

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `Customer eq '${BusinessPartner}'`,
      },
    };

    config.params = {
      ...config.params,
      $skip: skip,
    };

    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV`,
    });
    const response = await MainService.get('/ZAE_C_OutboundDeliveryLI_02', config).catch(
      throwSAPError
    );
    if (isResponseValid(response)) {
      const Data = response.data.d.results.map(r => ({
        Id: r.OutboundDelivery,
        DeliveryDate: r.DeliveryDate ? moment(r.DeliveryDate).format('MMMM DD, YYYY') : '',
      }));
      Data.sort((a, b) => b.OutboundDelivery - a.OutboundDelivery);
      downloadExcel(Data, 'AllDelivery.xlsx', 'Delivery');
    } else {
      throw new CustomException(i18n.t('deliveryScreenTranslations:INVALID_RESPONSE'));
    }
  } catch (error) {
    dispatch({
      type: SET_DELIVERY_TABLE_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('deliveryScreenTranslations:ERR_MSG_1'),
      },
    });

    enqueueSnackbar(i18n.t('deliveryScreenTranslations:ERR_MSG_1'), {
      variant: 'error',
    });
  }
};
